import { render, staticRenderFns } from "./RecordOrganizerBase.vue?vue&type=template&id=538fd3d7&scoped=true&"
import script from "./RecordOrganizerBase.vue?vue&type=script&lang=js&"
export * from "./RecordOrganizerBase.vue?vue&type=script&lang=js&"
import style0 from "./RecordOrganizerBase.vue?vue&type=style&index=0&id=538fd3d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538fd3d7",
  null
  
)

export default component.exports